/**
 * @generated SignedSource<<d8a6fbcb9c17bb4a1cb0d00d86921a5a>>
 * @relayHash 2cbac86c16686b5daea6a9f231fdf6b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0d0fb7c32d0c87191a5fee40c8f0c985952a7a8a909631e11a5751171decf376

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type list_hydrateJql_Query$variables = {
  cloudId: string;
  jql: string;
};
export type list_hydrateJql_Query$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly hydrateJqlQuery: {
        readonly __id: string;
        readonly " $fragmentSpreads": FragmentRefs<"fieldValueData_businessConditionalFormattingSidebar">;
      };
    } | null | undefined;
  };
};
export type list_hydrateJql_Query = {
  response: list_hydrateJql_Query$data;
  variables: list_hydrateJql_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jql"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "jql"
  }
],
v4 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "list_hydrateJql_Query",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v2/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v3/*: any*/),
                    "kind": "LinkedField",
                    "name": "hydrateJqlQuery",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "fieldValueData_businessConditionalFormattingSidebar"
                          }
                        ],
                        "type": "JiraJqlHydratedQuery"
                      },
                      (v4/*: any*/)
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.jqlBuilder.hydrateJqlQuery"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "list_hydrateJql_Query",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "hydrateJqlQuery",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraJqlField",
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "type"
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "values",
                                "plural": true,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": true,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v6/*: any*/),
                                          (v7/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "accountId"
                                                  },
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlUserFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraPriority",
                                                "kind": "LinkedField",
                                                "name": "priority",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "priorityId"
                                                  },
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlPriorityFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraSprint",
                                                "kind": "LinkedField",
                                                "name": "sprint",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "sprintId"
                                                  },
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlSprintFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraGroup",
                                                "kind": "LinkedField",
                                                "name": "group",
                                                "plural": false,
                                                "selections": [
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlGroupFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                  },
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlProjectFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "issueTypes",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "issueTypeId"
                                                  },
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlIssueTypeFieldValue"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraJqlQueryHydratedValue"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                          }
                        ]
                      }
                    ],
                    "type": "JiraJqlHydratedQuery"
                  },
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0d0fb7c32d0c87191a5fee40c8f0c985952a7a8a909631e11a5751171decf376",
    "metadata": {},
    "name": "list_hydrateJql_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "29ea070df4a573820b0818573b62d704";

export default node;
